const requiredRule = { required: 'This field is required' };

export default requiredRule;
